import MarkdownRenderer from '@lcsc-ui/components/MarkdownRenderer';

export default function ProductPDFDesc({ productPdfDescData }) {
  const isMroProduct = productPdfDescData?.isMroProduct;
  const productIntroVO = productPdfDescData?.productIntroVO;
  const productPDFDescVO = productPdfDescData?.productPDFDescVO;

  return (!isMroProduct && productPDFDescVO) || (isMroProduct && !productIntroVO) ? (
    <>
      {productPDFDescVO?.productIntro && (
        <section className="w-[810px] p-[20px] mt-[20px] rounded-[20px] bg-white">
          <h2 className="font-bold text-[18px] text-[#0B1832]">商品概述</h2>
          <MarkdownRenderer className="mt-[10px]" content={productPDFDescVO?.productIntro} />
        </section>
      )}
      {productPDFDescVO?.productFeatures && (
        <section className="w-[810px] p-[20px] mt-[20px] rounded-[20px] bg-white">
          <h2 className="font-bold text-[18px] text-[#0B1832]">商品特性</h2>
          <MarkdownRenderer className="mt-[10px]" content={productPDFDescVO?.productFeatures} />
        </section>
      )}
      {productPDFDescVO?.pdfApplicationAreas && (
        <section className="w-[810px] p-[20px] mt-[20px] rounded-[20px] bg-white">
          <h2 className="font-bold text-[18px] text-[#0B1832]">应用领域</h2>
          <MarkdownRenderer className="mt-[10px]" content={productPDFDescVO?.pdfApplicationAreas} />
        </section>
      )}
    </>
  ) : (
    <></>
  );
}
